module.exports = __webpack_public_path__ + "img/tmb_ch_khalida_0.12341304.png";